export default function selectJiraAreProjectsLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].projects.loading
}
